

export default function Header() {
    return(
        <div className="header-container">
            <img src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68dd7ded2655f58233b113dd/f1b83dcd8_BlackBeigeBoldFramedTypographyPlanetBrandBusinessLogo512x256px512x200px3.png" alt="" />
        </div>
    )
}
